/**
 * Cart-page shipping calculator. Delegated click + re-init hooks for AJAX section swaps.
 */

function provinceSelectorInitShipping() {
  const countryEl = document.getElementById('AddressCountry_Shipping');
  if (
    !countryEl ||
    countryEl.dataset.shippingProvinceInit === '1' ||
    typeof Shopify === 'undefined' ||
    !Shopify.CountryProvinceSelector
  ) {
    return;
  }

  try {
    new Shopify.CountryProvinceSelector('AddressCountry_Shipping', 'AddressProvince_shipping', {
      hideElement: 'AddressProvinceContainerNewShiping',
    });
    countryEl.dataset.shippingProvinceInit = '1';
  } catch (_) {
    delete countryEl.dataset.shippingProvinceInit;
  }
}

document.addEventListener('DOMContentLoaded', provinceSelectorInitShipping);

document.addEventListener('click', (e) => {
  const btn = e.target.closest('.shipping_calc_save');
  if (!btn) return;

  const shippingCountry = document.getElementById('AddressCountry_Shipping');
  const countryState = document.getElementById('AddressProvince_shipping');
  const shippingCountryZip = document.getElementById('ShippingAddressZip');
  const shippingRatePackage = document.querySelector('.shipping_rate_package');
  const shippingAddressWrapper = document.querySelector('.shipping_rate_message');

  if (
    !shippingCountry ||
    !countryState ||
    !shippingCountryZip ||
    !shippingRatePackage ||
    !shippingAddressWrapper
  ) {
    return;
  }

  if (shippingCountry.value !== '---') {
    btn.classList.add('loading');
    fetch(
      `/cart/shipping_rates.json?shipping_address%5Bzip%5D=${encodeURIComponent(
        shippingCountryZip.value
      )}&shipping_address%5Bcountry%5D=${encodeURIComponent(
        shippingCountry.value
      )}&shipping_address%5Bprovince%5D=${encodeURIComponent(countryState.value)}`
    )
      .then((response) => {
        if (response.ok) return response.json();
        throw window.shipping?.wrong_message || 'Unable to fetch shipping rates.';
      })
      .then((response) => {
        btn.classList.remove('loading');
        shippingAddressWrapper.classList.remove('no-js-inline');
        const countSpan = shippingAddressWrapper.querySelector('.shipping_address_count');
        if (countSpan) countSpan.textContent = String(response.shipping_rates.length);

        shippingRatePackage.innerHTML = '';
        response.shipping_rates.forEach((rate) => {
          const row = document.createElement('div');
          row.className = 'shipping-rate-row';

          const name = document.createElement('span');
          name.className = 'shipping-rate-row__name';
          name.textContent = rate.name;

          const price = document.createElement('span');
          price.className = 'shipping-rate-row__price';
          price.textContent = `${shopCurrencySymbol}${rate.price}`;

          row.append(name, price);
          shippingRatePackage.appendChild(row);
        });
      })
      .catch((err) => {
        btn.classList.remove('loading');
        shippingAddressWrapper.classList.add('no-js-inline');
        shippingRatePackage.innerHTML = `<p class="error mt-15">${String(err)}</p>`;
      });
  } else {
    shippingAddressWrapper.classList.add('no-js-inline');
    shippingRatePackage.innerHTML = `<p class="error mt-15">${window.shipping?.country_label || ''}</p>`;
  }
});

window.initCartShippingProvinceSelector = function () {
  const el = document.getElementById('AddressCountry_Shipping');
  if (el) delete el.dataset.shippingProvinceInit;
  provinceSelectorInitShipping();
};
